export enum ButtonType {
  PRIMARY = 'primary',
  PRIMARY_ALT = 'primary-alt',
  SECONDARY = 'secondary',
  SECONDARY_ALT = 'secondary-alt',
  LINK = 'link',
  PANTAMERA_PRIMARY = 'pantamera-primary',
  PANTAMERA_SECONDARY = 'pantamera-secondary',
}

export enum ButtonClass {
  Primary = 0,
  PrimaryAlt = 1,
  Secondary = 2,
  SecondaryAlt = 3,
  Link = 4,
  PantameraPrimary = 5,
  PantameraSecondary = 6
}

export type ButtonProps = {
  id?: string
  text: any
  type?: string | ButtonType
  disabled?: boolean
  className?: string
  loading?: boolean
  onClick: any
  role?: string
  ariaLabel?: string
  large?: boolean
  href?: string
  target?: string
  rel?: string
  ariaExpanded?: boolean
  ariaControls?: string
}
